import { createScreenLoadTimer, readNavigationType } from '@/utils/screen-load-timing/screenLoadTimer'

const readDeviceInfo = () => ({
  deviceMemoryGb: navigator.deviceMemory ?? null,
  cpuCores: navigator.hardwareConcurrency ?? null,
})

// Required lazily: the mixpanel util imports the store, which is still being built when the store plugin is registered.
const trackEvent = (eventName, properties) => {
  // eslint-disable-next-line global-require
  require('@/utils/mixpanel.utils').default.track(eventName, properties)
}

let screenLoadTimer = null
let isScreenLoadTimingEnabled = () => false

export const setScreenLoadTimingGate = (gate) => {
  isScreenLoadTimingEnabled = gate
}

const getScreenLoadTimer = () => {
  if (!screenLoadTimer) {
    screenLoadTimer = createScreenLoadTimer({
      now: () => performance.now(),
      getPageLoadType: () => readNavigationType(performance),
      getDeviceInfo: readDeviceInfo,
      isHidden: () => document.hidden,
      track: trackEvent,
      afterNextPaint: (callback) => requestAnimationFrame(() => requestAnimationFrame(callback)),
    })
  }
  return screenLoadTimer
}

export const markScreenNavigationStart = (to, from) => {
  try {
    // Ungated: flags load after the first navigation, so gating here would lose every first-load span.
    getScreenLoadTimer().markNavigationStart(to, from)
  } catch {
    // telemetry must never break a navigation
  }
}

export const markPresentStart = () => {
  try {
    if (!isScreenLoadTimingEnabled()) return
    getScreenLoadTimer().markPresentStart()
  } catch {
    // telemetry must never break presenting
  }
}

export const evaluateScreenLoad = (snapshot) => {
  try {
    getScreenLoadTimer().evaluate(snapshot)
  } catch {
    // telemetry must never break the store
  }
}
